// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CityContext$PorterinFeature from "../../../contexts/city-context/CityContext.mjs";
import * as SubmitBtnCmp$PorterinFeature from "../../../ui/components/SubmitBtnCmp.mjs";
import * as LeadFormSubmitButtonModuleScss from "./styles/LeadFormSubmitButton.module.scss";

var styles = LeadFormSubmitButtonModuleScss;

function LeadFormSubmitButtonCmp(Props) {
  var is_disabled = Props.is_disabled;
  var event_name = Props.event_name;
  var cta = Props.cta;
  var error = Props.error;
  var match = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  return React.createElement("div", {
              className: styles["submit-button-wrapper"]
            }, React.createElement(SubmitBtnCmp$PorterinFeature.make, {
                  is_disabled: is_disabled,
                  className: styles["submit-container"],
                  icon_label: {
                    icon: {
                      path: "https://dom-content-vault-prod-cdn-assets.porter.in/right_arrow_db54b8ed6d/right_arrow_db54b8ed6d.svg",
                      alt_text: ""
                    },
                    label: cta
                  },
                  category: match.category,
                  is_loading: is_disabled,
                  event_name: event_name
                }), React.createElement("div", {
                  className: styles["submit-button-error"]
                }, error));
}

var make = LeadFormSubmitButtonCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
